import { Row, Col, Button, Badge } from "reactstrap"

export const VehicleFuelUsageListHeader = ({
  handleAddNewClick,
  handleRefresh,
  resetParams,
  isRefetching,
  hasActiveFilters,
  total,
}) => {
  return (
    <Row className="align-items-center mb-3">
      <Col sm={6}>
        <h5 className="mb-0 mt-3 card-title flex-grow-1">
          Usage Fuel List <Badge className="badge-soft-info">{total ?? 0}</Badge>
        </h5>
      </Col>
      <Col sm={6} className="text-end">
        <Button color="primary" onClick={handleAddNewClick}>
          Add New
        </Button>
        <Button color="light" onClick={handleRefresh} className="ms-1">
          <i className={`mdi mdi-refresh ${isRefetching ? "mdi-spin" : ""}`} />
        </Button>
        {hasActiveFilters && (
          <Button color="danger" onClick={resetParams} className="ms-1">
            Reset Filters
          </Button>
        )}
      </Col>
    </Row>
  )
}
